import React, { useEffect } from "react";
import { Container, Card } from "react-bootstrap";
import AOS from "aos";

const TermsAndConditions = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      easing: "ease-out-cubic",
    });
  }, []);

  return (
    <div className="py-5" style={{ backgroundColor: "#f8fbff" }}>
      <Container className="py-5">
        <div className="text-center mb-5" data-aos="fade-up">
          <h2 className="display-5 fw-bold mb-4" style={{ color: "#0B2E59" }}>
            Terms and Conditions
          </h2>
          <div
            className="mx-auto mb-4"
            style={{
              width: "80px",
              height: "4px",
              background: "linear-gradient(90deg, #1D65A6 0%, #72A2C0 100%)",
              borderRadius: "2px",
            }}
          ></div>
        </div>

        <Card className="border-0 shadow-lg rounded-4 p-4 p-md-5" data-aos="fade-up" data-aos-delay="100">
          <Card.Body>
            <p>
              Welcome to The Innovative Solutions. These Terms and Conditions ("Terms", "Terms of Service", "Agreement") govern your access to and use of our website, applications, software, products, and services.
            </p>
            <p>
              By accessing or using our website and services, you agree to be legally bound by these Terms. If you do not agree with any part of these Terms, please refrain from using our website and services.
            </p>

            <hr className="my-4" />

            <h4 className="fw-bold" style={{ color: "#1D65A6" }}>1. Company Information</h4>
            <p>The Innovative Solutions provides professional technology services including but not limited to:</p>
            <ul>
              <li>Website Development</li>
              <li>Mobile Application Development</li>
              <li>Software Development</li>
              <li>Cloud Solutions</li>
              <li>Digital Marketing</li>
              <li>UI/UX Design</li>
              <li>Cybersecurity Services</li>
              <li>IT Consulting</li>
              <li>Software Maintenance & Support</li>
              <li>Custom Enterprise Solutions</li>
            </ul>

            <hr className="my-4" />

            <h4 className="fw-bold" style={{ color: "#1D65A6" }}>2. Acceptance of Terms</h4>
            <p>By using our website or engaging our services, you acknowledge that:</p>
            <ul>
              <li>You are at least 18 years of age.</li>
              <li>You have the legal authority to enter into binding agreements.</li>
              <li>All information provided by you is accurate and complete.</li>
              <li>You agree to comply with these Terms and applicable laws.</li>
            </ul>

            <hr className="my-4" />

            <h4 className="fw-bold" style={{ color: "#1D65A6" }}>3. Scope of Services</h4>
            <p>The Innovative Solutions offers services based on mutually agreed proposals, quotations, contracts, or project agreements.</p>
            <p>The scope of work may include:</p>
            <ul>
              <li>Requirement Analysis</li>
              <li>UI/UX Design</li>
              <li>Software Development</li>
              <li>Testing and Quality Assurance</li>
              <li>Deployment and Hosting Support</li>
              <li>Maintenance Services</li>
              <li>Technical Consulting</li>
            </ul>
            <p>Any work requested outside the agreed scope may be subject to additional charges and timelines.</p>

            <hr className="my-4" />

            <h4 className="fw-bold" style={{ color: "#1D65A6" }}>4. Project Engagement and Approval</h4>
            <p>Before project commencement:</p>
            <ul>
              <li>Clients must approve project requirements.</li>
              <li>Timelines and deliverables will be documented.</li>
              <li>Payment milestones must be agreed upon.</li>
              <li>Necessary project resources and information must be provided by the client.</li>
            </ul>
            <p>Failure to provide required information may affect project timelines.</p>

            <hr className="my-4" />

            <h4 className="fw-bold" style={{ color: "#1D65A6" }}>5. Client Responsibilities</h4>
            <p>Clients agree to:</p>
            <ul>
              <li>Provide accurate information and requirements.</li>
              <li>Review deliverables within reasonable timelines.</li>
              <li>Provide timely approvals and feedback.</li>
              <li>Maintain confidentiality of provided credentials.</li>
              <li>Obtain necessary licenses and permissions for content supplied to us.</li>
            </ul>
            <p>Clients are solely responsible for content uploaded to their websites, applications, or systems.</p>

            <hr className="my-4" />

            <h4 className="fw-bold" style={{ color: "#1D65A6" }}>6. Payment Terms</h4>
            <h5 className="mt-3">6.1 Payment Schedule</h5>
            <p>Payments shall be made according to agreed milestones, quotations, or contracts.</p>
            <p>Typical project structure may include:</p>
            <ul>
              <li>Advance Payment</li>
              <li>Development Milestone Payments</li>
              <li>Final Delivery Payment</li>
            </ul>

            <h5 className="mt-3">6.2 Delayed Payments</h5>
            <p>In case of delayed payments:</p>
            <ul>
              <li>Project work may be paused.</li>
              <li>Deliverables may be withheld.</li>
              <li>Access to completed work may be restricted.</li>
              <li>Additional charges may apply where legally permissible.</li>
            </ul>

            <h5 className="mt-3">6.3 Non-Refundable Payments</h5>
            <p>Unless otherwise stated in writing:</p>
            <ul>
              <li>Advance payments are non-refundable.</li>
              <li>Design, consultation, and development fees are non-refundable once work has commenced.</li>
            </ul>

            <hr className="my-4" />

            <h4 className="fw-bold" style={{ color: "#1D65A6" }}>7. Intellectual Property Rights</h4>
            <h5 className="mt-3">Client-Owned Content</h5>
            <p>Clients retain ownership of:</p>
            <ul>
              <li>Logos</li>
              <li>Trademarks</li>
              <li>Business Data</li>
              <li>Content provided by the client</li>
            </ul>

            <h5 className="mt-3">Company-Owned Assets</h5>
            <p>The Innovative Solutions retains ownership of:</p>
            <ul>
              <li>Internal Frameworks</li>
              <li>Development Methodologies</li>
              <li>Proprietary Tools</li>
              <li>Reusable Components</li>
              <li>Libraries and Templates created prior to the project</li>
            </ul>

            <h5 className="mt-3">Source Code Ownership</h5>
            <p>Ownership of source code shall be governed by the project agreement.</p>
            <p>Unless explicitly transferred in writing:</p>
            <ul>
              <li>Ownership remains with The Innovative Solutions until full payment is received.</li>
              <li>Final source code delivery occurs only after complete payment settlement.</li>
            </ul>

            <hr className="my-4" />

            <h4 className="fw-bold" style={{ color: "#1D65A6" }}>8. Confidentiality</h4>
            <p>Both parties agree to maintain confidentiality regarding:</p>
            <ul>
              <li>Business Information</li>
              <li>Trade Secrets</li>
              <li>Source Code</li>
              <li>Technical Documentation</li>
              <li>Project Data</li>
              <li>Login Credentials</li>
              <li>Customer Information</li>
            </ul>
            <p>Confidential information shall not be disclosed without prior written consent unless required by law.</p>

            <hr className="my-4" />

            <h4 className="fw-bold" style={{ color: "#1D65A6" }}>9. Acceptable Use Policy</h4>
            <p>Users agree not to:</p>
            <ul>
              <li>Violate applicable laws</li>
              <li>Attempt unauthorized access</li>
              <li>Introduce malware or malicious code</li>
              <li>Engage in fraudulent activities</li>
              <li>Exploit vulnerabilities</li>
              <li>Interfere with website operations</li>
              <li>Conduct denial-of-service attacks</li>
            </ul>
            <p>Violation may result in suspension or termination of services.</p>

            <hr className="my-4" />

            <h4 className="fw-bold" style={{ color: "#1D65A6" }}>10. Hosting and Infrastructure Services</h4>
            <p>Where hosting assistance is provided:</p>
            <ul>
              <li>Hosting services may be managed through third-party providers.</li>
              <li>Server uptime is subject to hosting provider availability.</li>
              <li>Maintenance windows may occasionally affect service availability.</li>
            </ul>
            <p>The Innovative Solutions is not responsible for outages caused by third-party hosting providers.</p>

            <hr className="my-4" />

            <h4 className="fw-bold" style={{ color: "#1D65A6" }}>11. Technical Support and Maintenance</h4>
            <p>Support services are provided according to agreed support plans.</p>
            <p>Support may include:</p>
            <ul>
              <li>Bug Fixes</li>
              <li>Performance Optimization</li>
              <li>Security Updates</li>
              <li>Technical Assistance</li>
            </ul>
            <p>Support does not include major feature additions unless specifically contracted.</p>

            <hr className="my-4" />

            <h4 className="fw-bold" style={{ color: "#1D65A6" }}>12. Security Policy</h4>
            <p>We implement industry-standard security practices including:</p>
            <ul>
              <li>SSL/TLS Encryption</li>
              <li>Firewall Protection</li>
              <li>Access Control Mechanisms</li>
              <li>Secure Authentication Practices</li>
              <li>Vulnerability Monitoring</li>
            </ul>
            <p>However, no system can guarantee complete security.</p>
            <p>Clients are responsible for protecting their passwords and access credentials.</p>

            <hr className="my-4" />

            <h4 className="fw-bold" style={{ color: "#1D65A6" }}>13. Third-Party Integrations</h4>
            <p>Projects may include integrations with third-party services such as:</p>
            <ul>
              <li>Payment Gateways</li>
              <li>SMS Providers</li>
              <li>Email Services</li>
              <li>Cloud Platforms</li>
              <li>APIs</li>
              <li>Analytics Tools</li>
            </ul>
            <p>The Innovative Solutions is not responsible for:</p>
            <ul>
              <li>Third-party outages</li>
              <li>Pricing changes</li>
              <li>API modifications</li>
              <li>Policy changes by third-party providers</li>
            </ul>

            <hr className="my-4" />

            <h4 className="fw-bold" style={{ color: "#1D65A6" }}>14. Project Delays</h4>
            <p>The Innovative Solutions shall not be liable for delays caused by:</p>
            <ul>
              <li>Client-side delays</li>
              <li>Late approvals</li>
              <li>Incomplete requirements</li>
              <li>Third-party service interruptions</li>
              <li>Force majeure events</li>
              <li>Regulatory restrictions</li>
            </ul>
            <p>Project timelines may be revised accordingly.</p>

            <hr className="my-4" />

            <h4 className="fw-bold" style={{ color: "#1D65A6" }}>15. Warranties Disclaimer</h4>
            <p>All services are provided on an "As Is" and "As Available" basis.</p>
            <p>We do not guarantee:</p>
            <ul>
              <li>Uninterrupted website availability</li>
              <li>Error-free operation</li>
              <li>Compatibility with all devices</li>
              <li>Specific business outcomes</li>
              <li>Search engine rankings</li>
              <li>Revenue generation</li>
            </ul>

            <hr className="my-4" />

            <h4 className="fw-bold" style={{ color: "#1D65A6" }}>16. Limitation of Liability</h4>
            <p>To the maximum extent permitted by law, The Innovative Solutions shall not be liable for:</p>
            <ul>
              <li>Indirect Damages</li>
              <li>Consequential Damages</li>
              <li>Data Loss</li>
              <li>Business Interruption</li>
              <li>Loss of Revenue</li>
              <li>Loss of Profits</li>
              <li>Cybersecurity Incidents beyond reasonable control</li>
            </ul>
            <p>Our total liability shall not exceed the amount paid by the client for the relevant service.</p>

            <hr className="my-4" />

            <h4 className="fw-bold" style={{ color: "#1D65A6" }}>17. Indemnification</h4>
            <p>Clients agree to indemnify and hold harmless The Innovative Solutions from claims arising from:</p>
            <ul>
              <li>Client-provided content</li>
              <li>Copyright violations</li>
              <li>Trademark disputes</li>
              <li>Misuse of delivered software</li>
              <li>Illegal activities conducted using delivered solutions</li>
            </ul>

            <hr className="my-4" />

            <h4 className="fw-bold" style={{ color: "#1D65A6" }}>18. Termination of Services</h4>
            <p>We reserve the right to suspend or terminate services if:</p>
            <ul>
              <li>Terms are violated.</li>
              <li>Fraudulent activity is detected.</li>
              <li>Payments remain unpaid.</li>
              <li>Abuse of support services occurs.</li>
              <li>Illegal activities are identified.</li>
            </ul>

            <hr className="my-4" />

            <h4 className="fw-bold" style={{ color: "#1D65A6" }}>19. Force Majeure</h4>
            <p>Neither party shall be liable for failure to perform obligations caused by events beyond reasonable control, including:</p>
            <ul>
              <li>Natural Disasters</li>
              <li>Floods</li>
              <li>Earthquakes</li>
              <li>Cyber Attacks</li>
              <li>Government Actions</li>
              <li>Internet Outages</li>
              <li>Power Failures</li>
              <li>Pandemics</li>
            </ul>

            <hr className="my-4" />

            <h4 className="fw-bold" style={{ color: "#1D65A6" }}>20. Governing Law and Jurisdiction</h4>
            <p>These Terms shall be governed by and interpreted in accordance with the laws of India.</p>
            <p>Any disputes arising from these Terms shall be subject to the exclusive jurisdiction of the courts located in Nashik, Maharashtra, India.</p>

            <hr className="my-4" />

            <h4 className="fw-bold" style={{ color: "#1D65A6" }}>21. Changes to Terms</h4>
            <p>We reserve the right to modify these Terms at any time.</p>
            <p>Updated versions will be posted on this page with the revised effective date.</p>
            <p>Continued use of our services constitutes acceptance of the updated Terms.</p>
          </Card.Body>
        </Card>
      </Container>
    </div>
  );
};

export default TermsAndConditions;
